import { render, staticRenderFns } from "./Pdp.vue?vue&type=template&id=46d7c3ef&lang=pug"
import script from "./Pdp.vue?vue&type=script&lang=js"
export * from "./Pdp.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports